'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import FolderTreeContainer from 'FileManagerCore/containers/FolderTreeContainer';
import { getFolders } from 'FileManagerCore/selectors/Folders';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import { getCurrentFolder } from '../../selectors/FoldersAndFiles';
import { getSelectedFilesAndFolders } from '../../selectors/Selection';
import { isFile, getHomeFolder } from 'FileManagerCore/utils/FoldersAndFiles';
import { bulkMove } from '../../actions/Bulk';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class BulkMoveButton extends Component {
  constructor(props) {
    super(props);
    this.handleFolderSelect = folder => {
      this.setState({
        selectedFolder: folder
      });
    };
    this.handleMove = () => {
      const {
        onBulkMove,
        bulkSelection
      } = this.props;
      const {
        selectedFolder
      } = this.state;
      onBulkMove(bulkSelection, selectedFolder);
      this.setState(this.initialState(this.props));
    };
    this.handleMoveButtonClick = () => {
      this.setState({
        isOpen: true
      });
    };
    this.handleClose = () => {
      this.setState(this.initialState(this.props));
    };
    this.state = this.initialState(props);
  }
  initialState(props) {
    return {
      isOpen: false,
      selectedFolder: props.parentFolder
    };
  }
  hasMoved() {
    const {
      parentFolder
    } = this.props;
    const {
      selectedFolder
    } = this.state;
    return selectedFolder.get('id') !== parentFolder.get('id');
  }
  render() {
    const {
      parentFolder,
      folders,
      bulkSelection,
      isReadOnly
    } = this.props;
    const {
      isOpen,
      selectedFolder
    } = this.state;
    if (folders.size === 0) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ScopedFeatureTooltip, {
        children: /*#__PURE__*/_jsxs(UILink, {
          onClick: this.handleMoveButtonClick,
          disabled: isReadOnly,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "folderOpen"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "FileManagerDashboard.actions.move"
          })]
        })
      }), isOpen && /*#__PURE__*/_jsxs(UIModal, {
        width: 500,
        size: "auto",
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: this.handleClose
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "FileManagerDashboard.moveModal.moveSelected"
            })
          })]
        }), /*#__PURE__*/_jsxs(UIDialogBody, {
          className: "move-button--modal-body",
          children: [this.hasMoved() && /*#__PURE__*/_jsx("p", {
            className: "m-bottom-4",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "FileManagerDashboard.moveModal.bulkMovedInTo",
              options: {
                source: parentFolder.get('name'),
                destination: selectedFolder.get('name')
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "move-button--folder-tree-wrapper",
            children: /*#__PURE__*/_jsx(FolderTreeContainer, {
              exclusions: bulkSelection.toList().filter(object => !isFile(object)).map(folder => folder.get('id')).toSet(),
              selectedFolder: selectedFolder,
              onSelect: this.handleFolderSelect
            })
          })]
        }), /*#__PURE__*/_jsxs(UIDialogFooter, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            disabled: !this.hasMoved(),
            onClick: this.handleMove,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "FileManagerDashboard.actions.move"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: this.handleClose,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "FileManagerDashboard.actions.cancel"
            })
          })]
        })]
      })]
    });
  }
}
BulkMoveButton.propTypes = {
  bulkSelection: PropTypes.instanceOf(Immutable.Map).isRequired,
  parentFolder: PropTypes.instanceOf(Immutable.Map).isRequired,
  folders: PropTypes.instanceOf(Immutable.List).isRequired,
  onBulkMove: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired
};
const mapStateToProps = (state, props) => {
  return {
    bulkSelection: getSelectedFilesAndFolders(state),
    folders: getFolders(state),
    parentFolder: getCurrentFolder(state, props) || getHomeFolder(),
    isReadOnly: getIsReadOnly(state)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onBulkMove(bulkSelection, destination) {
      dispatch(bulkMove(bulkSelection, destination));
    }
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BulkMoveButton));